export var TestContainerActionTypes;
(function (TestContainerActionTypes) {
    TestContainerActionTypes["DECREMENT_COUNT"] = "DECREMENT_COUNT";
    TestContainerActionTypes["INCREMENT_COUNT"] = "INCREMENT_COUNT";
})(TestContainerActionTypes || (TestContainerActionTypes = {}));
